import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { Row, Col, Form, DatePicker, Select, Button, notification } from '@duxton-web/ui';
import SegPWidget from 'components/form/trident-campaigns/SegPWidget';
import LeadingIcon from 'img/jb_leading.svg';
import LaunchIcon from 'img/ucd_launch.svg';

const TARGET_USER_TYPE = 'passenger';

const StartJourneyForm = props => {
  const { form, showSegmentModal } = props;
  useEffect(() => {}, [props.node]);
  const [startTime, setStartTime] = useState(
    form.current.getFieldValue([
      props.node.id,
      'data',
      'schedule',
      'startTime',
    ]),
  );

  const [endTime, setEndTime] = useState(
    form.current.getFieldValue([
      props.node.id,
      'data',
      'schedule',
      'endTime',
    ]),
  );

  const [frequency, setFrequency] = useState(
    form.current.getFieldValue([
      props.node.id,
      'data',
      'schedule',
      'frequency',
    ]),
  );

  // TODO: moving to constants
  const frequencyOptions = [
    { value: 'nr', label: "Don't Repeat" },
    { value: 'da', label: 'Daily' },
    { value: 'wk', label: 'Weekly' },
    { value: 'mt', label: 'Monthly' },
  ];

  const onRepeatChange = (value) => {
    const { form, node } = props;
    setFrequency(value);

    if (value === 'nr') {
      const newEndTime = dayjs(startTime).add(1, 'week');
      form.current.setFieldValue(
        [node.id, 'data', 'schedule', 'endTime'],
        newEndTime, // to make sure end date is after start date
      );
      setEndTime(newEndTime.toString());
    }
  };

  const onStartTimeChange = (day, dayStr) => {
    const { form, node } = props;
    const triggerNotification = content => {
      const key = `open${Date.now()}`;
      const btn = (
        <Button
          type="primary"
          size="small"
          onClick={() => notification.destroy(key)}
        >
          OK
        </Button>
      );
      notification.open({
        message: <b style={{ fontSize: 20 }}>Warning</b>,
        description: <span style={{ color: '#3D3D3D' }}>{content}</span>,
        btn,
        key,
        duration: 0,
      });
    };

    setStartTime(dayStr);
    if (day > dayjs(endTime) && frequency !== 'nr') {
      triggerNotification(
        'Kindly ensure that the chosen start date precedes the end date.',
      );
    } else if (day <= dayjs()) {
      triggerNotification(
        'Kindly ensure that the chosen start date is at least 15 minutes from now.',
      );
    }

    if (frequency === 'nr' && day > dayjs(endTime)) {
      const newEndTime = dayjs(day).add(1, 'week');
      form.current.setFieldValue(
        [node.id, 'data', 'schedule', 'endTime'],
        newEndTime, // to make sure end date is after start date
      );
      setEndTime(newEndTime.toString());
    }
  };

  const onEndTimeChange = (day, dayStr) => {
    setEndTime(dayStr);
  };

  const disabledEndDate = currentDate => {
    return currentDate && currentDate < dayjs(startTime).add(2, 'day');
  };

  return (
    <div className="jb-form-journey-start">
      <Row>
        <Col span={24}>
          <h3>1. Trigger</h3>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <div className="scheduleIntro">
            <div>
              <img src={LeadingIcon} alt="" />
            </div>
            <div>
              <b>Schedule</b>
              <span>Trigger the journey at a specific time</span>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            rules={[{ required: true, message: 'Please select segment' }]}
            label="User segment"
            name={[props.node.id, 'data', 'userSource', 'sourceID']}
          >
            <SegPWidget
              targetUserType={TARGET_USER_TYPE}
              segmentVal={props.node.data.userSource.sourceID}
              maxVisible={30}
              enabledSegmentNSFormat
              showNsDropdown={false}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row className="segmentInfo" style={{ marginBottom: 12 }}>
        <Col span={24}>
          <Button
            target="_blank"
            href={window.Grab.config.SEGMENTATION_PLATFORM_URI}
            style={{ marginRight: 8 }}
            size="small"
          >
            Create new segment <img src={LaunchIcon} alt="" />
          </Button>
          <Button onClick={showSegmentModal} size="small">
            View breakdown
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            rules={[
              { required: true, message: 'Please select time' },
              {
                validator: (_, value) => {
                  return (frequency !== 'nr' && dayjs(value) > dayjs(endTime))
                    ? Promise.reject(new Error('The start time must be earlier than the end time'))
                    : Promise.resolve();
                },
              },
              {
                validator: (_, value) => {
                  return dayjs(value) < dayjs().add(15, 'minutes')
                    ? Promise.reject(new Error('The start time must be at least 15 minutes from now'))
                    : Promise.resolve();
                },
              },
            ]}
            label="Time"
            name={[props.node.id, 'data', 'schedule', 'startTime']}
            getValueProps={i => ({ value: dayjs(i) })}
          >
            <DatePicker
              onChange={onStartTimeChange}
              format="YYYY-MM-DD HH:mm"
              showTime
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            rules={[{ required: true, message: '' }]}
            label="Repeat"
            name={[props.node.id, 'data', 'schedule', 'frequency']}
          >
            <Select onChange={onRepeatChange} options={frequencyOptions} />
          </Form.Item>
        </Col>
      </Row>
      {frequency !== 'nr' && (
        <Row>
          <Col span={24}>
            <Form.Item
              rules={[
                { required: true, message: 'Please select end time' },
                {
                  validator: (_, value) => {
                    switch (frequency) {
                      case 'wk':
                        return (dayjs(startTime).add(1, 'week').isAfter(dayjs(value), 'day'))
                          ? Promise.reject(new Error('The end time must be at least 1 week from now'))
                          : Promise.resolve();
                      case 'mt':
                        return (dayjs(startTime).add(1, 'month').isAfter(dayjs(value), 'day'))
                          ? Promise.reject(new Error('The end time must be at least 1 month from now'))
                          : Promise.resolve();
                      default:
                        break;
                    }
                  },
                },
              ]}
              label="Ends"
              name={[props.node.id, 'data', 'schedule', 'endTime']}
              getValueProps={i => ({ value: dayjs(i) })}
            >
              <DatePicker
                onChange={onEndTimeChange}
                disabledDate={disabledEndDate}
                format="YYYY-MM-DD HH:mm"
                showTime
              />
            </Form.Item>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default StartJourneyForm;
